"use client";

import * as React from "react";
import type { LegendProps } from "recharts";
import { ExploreChartLegend } from "@/components/explore-chart-legend";
import { toggleHideChart } from "./toggle-hide-chart";

type ExploreLegendOptions = {
  lineKeys: string[];
  hidden: string[];
  onHiddenChange: React.Dispatch<React.SetStateAction<string[]>>;
  xAxisLabel?: string;
};

export function exploreLegendProps({
  lineKeys,
  hidden,
  onHiddenChange,
  xAxisLabel = "Time [Days]",
}: ExploreLegendOptions): any {
  return {
    align: "center",
    verticalAlign: "bottom",
    wrapperStyle: {
      width: "100%",
      left: 0,
      right: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
    content: (props: LegendProps) => (
      <ExploreChartLegend
        {...props}
        lineKeys={lineKeys}
        hidden={hidden}
        onHiddenChange={onHiddenChange}
        xAxisLabel={xAxisLabel}
        onClick={(event) => {
          toggleHideChart({
            event,
            state: hidden,
            setState: onHiddenChange,
          });
        }}
      />
    ),
  };
}

export function legendConfig(options?: LegendProps) {
  return {
    iconSize: 16,
    iconType: "diamond",
    formatter: (value: string) => (
      <span className="mt-6 translate-y-px text-sm inline-block">{value}</span>
    ),
    ...options,
  } as LegendProps;
}

export default legendConfig;
